<template>
  <div id="container">
    <v-dialog v-model="enable" max-width="450" persistent>
      <v-card>
          <div class="poll__content">
             <v-icon x-large color="red" class="mx-auto">warning</v-icon>
              <h5> {{ title }}</h5>
        <v-card-text v-html="description"></v-card-text>
          </div>
        <v-card-actions class="justify-center">
          <v-btn class="btn--poll" flat="flat" @click="cancel">En otro momento</v-btn>
          <v-btn class="btn--poll accept" style="color: white;" flat="flat" @click="ok">Contestar Encuesta</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'title', 'description'],
  data() {
    return {
      enable: this.value,
    }
  },
  watch: {
    value() {
      this.enable = this.value
    },
  },
  methods: {
    cancel() {
      this.$emit('input', !this.value)
      this.$emit('desition', false)
    },
    ok() {
      this.$emit('input', !this.value)
      this.$emit('desition', true)
    },
  },
}
</script>

<style scoped>
.title {
  text-align: center;
}
h5{
  font-size: 17px;
}
.poll__content{
  width: 100%;
  text-align: center;
  padding: 10px 0px 0px 0px;
}
.btn--poll{
  border-radius: 10px;
  border: 1px solid #C1C3C6;
}
.accept{
  color: white;
  background: #F06B71;
}
</style>
